let language = {
    STORE_AUTH_MODAL_TITLE: "更新 Shopify 应用",
    STORE_AUTH_ACCESS_TEXT: "请授权 {{appName}} 访问以下内容：",
    STORE_AUTH_FOLLOWING_SERVICE: "如果您同意授予 {{appName}} 访问上述内容的权限，您将能够添加以下 {{appName}} 服务：",

    STORE_AUTH_CONFIRM_UPDATE_BTN_TEXT: "更新",

    STORE_AUTH_SCOPE_DISCOUNT: "访问折扣功能",
    STORE_AUTH_SCOPE_PRICE_RULE: "访问价格规则管理",
    STORE_AUTH_SCOPE_SHIPPING: "访问配送详情",
    STORE_AUTH_SCOPE_ASSIGNED_FULFILLMENT_ORDERS: "访问分配发货订单",
    STORE_AUTH_SCOPE_DELIVERY_CUSTOMIZATIONS: "访问交付定制",
    STORE_AUTH_FULFILLMENTS: "访问发货详情",
    STORE_AUTH_MANAGED_FULFILLMENT_ORDER: "访问管理发货订单",
    STORE_AUTH_LOCATIONS: "访问位置",
    STORE_AUTH_SCOPE_APP: "应用",
    STORE_AUTH_SCOPE_YOUR_STORE: "您的店铺",
    STORE_AUTH_SCOPE_ACCESS_DESCRIPTION: `为了利用 {{appName}} 的最新功能，请授权 {{appName}} 访问以下内容。`,
    
    STORE_AUTH_FEATURE_PRICE_TABLE: "价格表",
    STORE_AUTH_FEATURE_SHIPPING_METHOD: "配送方式",
    STORE_AUTH_FEATURE_TRACKING_NO: "快递单号",
    
    STORE_AUTH_SCOPE_ACCESS_DESCRIPTION_COMPLETED: "您的店铺已成功升级。请刷新页面以获取最新的店铺状态。"
};

export { language }
